export default "__VITE_ASSET__BoNrrEjf__"